import 'scripts/bem'

// load the stylin
import '../_bundles/blocks.css'

// load the common blocks
import * as blocks from '../_bundles/blocks.js'

// load the run script
import Compiler from 'scripts/run.js'

Compiler.run(blocks)
